import { ConfigService } from './config.service';

export function initializeApp(appConfigService: ConfigService) {
    return (): Promise<any> => { 
      return appConfigService.loadAppConfig();
    }
  }